export const UPLOAD_URL = "https://api.herb.apcfss.in/dms/onboarding/upload";
export const PRR_Docs_Pdf = 'https://api.dev.herb.apcfss.in/dms/user-defined-path/file-upload/prrdocs';

const prod = {
    url: {
        API_URL: 'https://api.affiliation.apcfss.in/affiliation/',
        FILE_UPLOAD_URL: 'https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-upload/bucket/affiliation-documents/affiliation/',
        FILE_DOWNLOAD_URL: 'https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/bucket/affiliation-documents/',
        IGRS_URL: 'https://api.affiliationffca.apcfss.in/afflffca/'

    }
};
const protocol = window.location.protocol === "https:" ? "https" : "http";
const dev = {
    url: {

        API_URL: 'https://swapi.dev.nidhi.apcfss.in/affiliation2026-27/', //DEV
        FILE_UPLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation",
        FILE_DOWNLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
    }
};

const local = {
    url: {
        API_URL: `${protocol}://172.16.119.243:8888/affiliation2026-27/`, //Pavani  /

        //  API_URL: `${protocol}://172.16.119.131:8888/affiliation2026-27/`, //srinu  /

        // API_URL: `${protocol}://172.16.119.131:8888/affiliation2026-27/`, //srinu  


        // API_URL: 'https://swapi.dev.nidhi.apcfss.in/affiliation/', //DEV
        LOGIN_API_URL: `${protocol}://172.16.119.243:8888/affiliation2026-27/auth/authenticate`,

        //   API_URL: 'https://swapi.dev.nidhi.apcfss.in/affiliation/', //DE
        FILE_UPLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation/`,
        FILE_DOWNLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/`,
        IGRS_URL: 'https://swapi.dev.nidhi.apcfss.in/afflffca/'


    }

};


export const config = process.env.NODE_ENV === 'development' ? local : dev; 
